import React, { Suspense, useState, useEffect, useLayoutEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { LinearProgress } from '@material-ui/core';

const CleanLayout = props => {

  const { route } = props;

  return (
    <>

      <Suspense fallback={
        <div>
          <LinearProgress />
        </div>
      }>

        <main>
          <div>
            {renderRoutes(route.routes)}
          </div>
        </main>

      </Suspense>
    </>
  );
}

export default CleanLayout;